import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BillingRoutingModule } from './billing-routing.module';
import { CoreModule } from 'app/core/core.module';
import { BillingComponent } from './pages/billing/billing.component';
import { SiteListModule } from '@components/site-list/site-list.module';
import { CompanyListModule } from '@components/company-list/company-list.module';
import { MaterialListModule } from '@components/material-list/material-list.module';
import { BillingTodoComponent } from './components/billing-todo/billing-todo.component';
import { BillingDoneComponent } from './components/billing-done/billing-done.component';
import { MonthSelectComponent } from './components/month-select/month-select.component';
import { DoItModalModule } from './components/do-it-modal/do-it-modal.module';
import { BillingFreeComponent } from './components/billing-free/billing-free.component';
import { BillingFreeItemModule } from './components/billing-free-item/billing-free-item.module';

@NgModule({
  imports: [
    BillingRoutingModule,
    CommonModule,
    CoreModule,
    SiteListModule,
    CompanyListModule,
    MaterialListModule,
    DoItModalModule,
    BillingFreeItemModule
  ],
  declarations: [
    BillingComponent,
    BillingTodoComponent,
    BillingDoneComponent,
    MonthSelectComponent,
    BillingFreeComponent
  ]
})
export class BillingModule { }
